import styled, { css, Breakpoint, Spacing, Font, Color, Utils } from '@nfinite/react-hubstairs/styled'

export const LAYOUT_CONFIGURATION = {
  HORIZONTAL: 'horizontal layout',
  VERTICAL: 'vertical layout',
}

export const Container = styled('div')`
  width: 100%;
`

const labelCss = css`
  color: ${Color.get('text', 'gray')};
  ${Utils.generateEllipsisMultiline('m', 2)}
  ${({ htmlFor }) => htmlFor && `cursor: pointer;`}
`

const LabelCapped = styled('label')`
  ${({ layoutConfiguration }) =>
    layoutConfiguration === LAYOUT_CONFIGURATION.VERTICAL
      ? css`
          width: 100%;
          ${Spacing.generateMargin({ bottom: 'xs' })}
          ${labelCss}
        `
      : css`
          width: 100%;
          ${Spacing.generateMargin({ bottom: 'xs' })}
          ${Spacing.generatePadding({ horizontal: 'm' })}
          ${labelCss}
  
          ${Breakpoint.greaterThanMobile()} {
            width: 150px;
            min-width: 150px;
            ${Spacing.generateMargin({ bottom: '0', right: 'm' })}
            ${Spacing.generatePadding({ horizontal: '0' })}
          }
        `}
`

const ContentLabelCapped = styled('div')`
  width: 100%;

  ${Breakpoint.greaterThanMobile()} {
    ${({ layoutConfiguration }) =>
      layoutConfiguration !== LAYOUT_CONFIGURATION.VERTICAL &&
      css`
        width: auto;
        flex-grow: 1;
      `}
  }
`

export const WrapperCapped = styled('div')`
  ${({ layoutConfiguration }) =>
    layoutConfiguration === LAYOUT_CONFIGURATION.VERTICAL
      ? css`
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        `
      : css`
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          ${Breakpoint.greaterThanMobile()} {
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-between;
          }
        `}
`

WrapperCapped.Label = styled(LabelCapped)`
  ${({ layoutConfiguration }) =>
    layoutConfiguration !== LAYOUT_CONFIGURATION.VERTICAL &&
    css`
      ${Spacing.generateMargin({ top: 's' })}
    `}
`
WrapperCapped.Content = ContentLabelCapped

export const WrapperCappedCentered = styled(WrapperCapped)`
  ${Breakpoint.greaterThanMobile()} {
    ${({ layoutConfiguration }) =>
      layoutConfiguration !== LAYOUT_CONFIGURATION.VERTICAL &&
      css`
        align-items: center;
      `}
  }
`

WrapperCappedCentered.Label = LabelCapped
WrapperCappedCentered.Content = ContentLabelCapped

export const Error = styled('p')`
  ${Font.generate({ size: 's' })}
  color: ${Color.get('alert')};
  ${Spacing.generateMargin({ top: 'xxs', bottom: '0' })}
`

export const Required = styled('sup')`
  font-size: 1.5rem;
  margin-left: 5px;
  top: 0;
`
